import React, { useState } from "react";
import Beatloader from "../../../Common/Loaders/Beatloader";
import CurrencyCreateForm from "./components/CurrencyCreateForm";
import LedgerAccount from "./components/LedgerAccount";
import { Table } from "antd";
import GroupMaster from "./components/GroupMaster";
import LedgerAccountList from "./components/LedgerAccountList";

const MasterManagement = () => {
  const [activeTab, setActiveTab] = useState("group");
  const [pageLoader, setPageLoader] = useState(false);
  const [groupFormData, setGroupFormData] = useState({
    GroupCode: "",
    name: "",
    parent: "",
    groupType: "",
    subGroupType: "",
    active: "",
  });

  const TabButton = ({ id, label }) => (
    <button
      className={`btn mx-1 px-4 py-2 rounded-pill ${
        activeTab === id
          ? "btn-light shadow-sm border"
          : "btn-outline-light text-muted border"
      }`}
      style={{
        background: activeTab === id ? "#ffffff" : "#f5f5f5",
        borderColor: "#e4e4e4",
      }}
      onClick={() => setActiveTab(id)}
    >
      {label}
    </button>
  );

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    setGroupFormData((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const submitGroupForm = () => {
    alert("1");
    console.log("groupFormData", groupFormData);
  };

  const clearGroupForm = () => {
    setGroupFormData({
      GroupCode: "",
      name: "",
      parent: "",
      groupType: "",
      subGroupType: "",
      active: "",
    });
  };

  return (
    <>
      {pageLoader ? (
        <Beatloader />
      ) : (
        <div className="page-wrapper">
          <div className="content">
            {/* Tabs */}
            <div className="d-flex flex-wrap align-items-center mb-4 gap-2">
              <TabButton id="group" label="Group Master" />
              <TabButton id="ledger_list" label="All Ledger Accounts" />
              <TabButton id="ledger" label="Ledger Account" />
              <TabButton id="currency" label="Currency Master" />
            </div>

            <div className="card p-4">
              {/* GROUP FORM -------------------------------------------------- */}
              {activeTab === "group" && <GroupMaster />}

              {/* LEDGER LIST */}
              {activeTab === "ledger_list" && <LedgerAccountList />}

              {/* LEDGER */}
              {activeTab === "ledger" && <LedgerAccount />}

              {/* CURRENCY */}
              {activeTab === "currency" && <CurrencyCreateForm />}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MasterManagement;
